import config from 'config/Config';
import BaseApi from './BaseApi';
import { EventPermissions } from 'types/store/normalized';

export class EventPermissionsApi extends BaseApi<EventPermissions> {
  constructor() {
    super(
      `${config.get('backendURL')}v2/facilitation-management/permissions/query`
    );
  }
}
